// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"649":"8c5a2397","875":"3195b074"}[chunkId] + ".chunk.js";
};